import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchDebtors(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/debtor/list', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchDebtor(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/debtor/view?id=${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addDebtor(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/debtor/create', { ...userData })
          .then(response => {
            resolve(response)
          })

          .catch(error => reject(error.response))
      })
    },
    editDebtor(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/debtor/edit', { ...userData })
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error.response))
      })
    },
  },
}
